import React from 'react';

function SalesInvoiceSearchFilters({ filters, onChange, onSearch, onReset, loading }) {
  return (
    <form onSubmit={onSearch} className="mb-3">
      <div className="row g-3">
        <div className="col-md-2">
          <label className="form-label mb-0 small">Customer Name</label>
          <input
            className="form-control"
            name="customer_name"
            value={filters.customer_name}
            onChange={onChange}
          />
        </div>

        <div className="col-md-2">
          <label className="form-label mb-0 small">Customer PO No</label>
          <input
            className="form-control"
            name="customer_po_no"
            value={filters.customer_po_no}
            onChange={onChange}
          />
        </div>

        <div className="col-md-2">
          <label className="form-label mb-0 small">Delivery Date From</label>
          <input
            type="date"
            className="form-control"
            name="po_date_from"
            value={filters.po_date_from}
            onChange={onChange}
          />
        </div>

        <div className="col-md-2">
          <label className="form-label mb-0 small">Delivery Date To</label>
          <input
            type="date"
            className="form-control"
            name="po_date_to"
            value={filters.po_date_to}
            onChange={onChange}
          />
        </div>

        <div className="col-md-2">
          <label className="form-label mb-0 small">Vehicle Details</label>
          <select
            className="form-select"
            name="vehicle_status"
            value={filters.vehicle_status}
            onChange={onChange}
          >

             <option value="pending">Pending</option>
            <option value="">All</option>
           
            <option value="done">Done</option>
          </select>
        </div>

        <div className="col-md-2">
          <label className="form-label mb-0 small">Billing Details</label>
          <select
            className="form-select"
            name="billing_status"
            value={filters.billing_status}
            onChange={onChange}
          >
            <option value="">All</option>
            <option value="pending">Pending</option>
            <option value="done">Done</option>
          </select>
        </div>

        <div className="col-md-2 d-flex align-items-end">
          <button className="btn btn-primary w-100" type="submit" disabled={loading}>
            {loading ? 'Loading...' : 'Search'}
          </button>
        </div>

        <div className="col-md-2 d-flex align-items-end">
          <button className="btn btn-secondary w-100" type="button" onClick={onReset}>
            Reset
          </button>
        </div>
      </div>
    </form>
  );
}

export default SalesInvoiceSearchFilters;
